<script setup>
    import { exerciseDataNameToLabelRemapper } from '../exercise-helpers.js';

    const emit = defineEmits(['selection-updated']);

    const props = defineProps({
        options: {
            type: Array,
            default: () => [],
        },
        defaultOption: {
            type: String,
            default: null,
        },

        isSticky: {
            type: Boolean,
            default: false,
        },

        type: {
            type: String,
            default: 'exercise',
        },

        inputName: {
            type: String,
            required: true,
        },

        label: {
            type: String,
            required: true,
        },

        selectedValue: {
            type: [String, Number, Boolean, Object],
            default: null,
        },
    });
   
    function updateValue(newValue) {
        emit('selection-updated', newValue);
    }
</script>

<template>
    <fieldset :id="props.inputName" class="optionSelector" :class="{ 'is-sticky' : props.isSticky }" :data-type="props.type">
        <legend class="visually-hidden">{{ label }}</legend>

        <div class="optionSelector__option" v-for="(option, index) in options" :key="option">
            <input type="radio" class="optionSelector__radio" :id="props.inputName + index" :name="props.inputName" :value="option" :checked="option === props.selectedValue" @change="updateValue(option)">
            <label class="optionSelector__button" :for="props.inputName + index" v-if="type === 'exercise'">{{ exerciseDataNameToLabelRemapper(option) }}</label>
            <label class="optionSelector__button" :for="props.inputName + index" v-else>{{ option }}</label>
        </div>
    </fieldset>
</template>

<style lang="scss">
    $border-radius: 8px;
    $default-bg-color: #fff;
    $active-bg-color: #e2e4e6;
    $border-color: #E1E1E1;
    $text-color: #161619;

    $default-bg-color: #21282e;
    $active-bg-color: #1E1E23;
    $active-bg-color: var(--primary-color);
    $border-color: #414143;
    $text-color: #fff;

    .optionSelector {
        display: inline-flex;
        justify-content: center;
        margin-bottom: 1rem;
        border: 1px solid $border-color;
        border-radius: $border-radius;
        background-color: $default-bg-color;
        overflow: hidden;
        box-shadow: 0 2px 4px 0 #1010104f;
        padding: 0;

        &.is-sticky {
            position: sticky;
            top: 0;
            z-index: 100;

            &[data-type="person"] {
                top: 5px;
            }

            &[data-type="exercise"] {
                top: 55px;
            }
        }

        &__radio {
            //display: none;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0;
            
            &:focus-visible + .optionSelector__button {
                outline: 2px solid white;
                outline-offset: -2px;
            }

            &:checked + .optionSelector__button {
                background-color: $active-bg-color;
                text-shadow: 0 1px 1px rgb(16 16 16 / 100%);
            }
        }

        &__option:not(:last-child) {
            border-right: 1px solid $border-color;
        }

        &__button {
            padding: 0.5rem 1rem;
            cursor: pointer;
            color: $text-color;
            display: inline-block;
            font-weight: 450;
            text-transform: capitalize;
            font-size: 16px;
            height: 100%;
            z-index: 300;
            position: relative;
        }
    }
</style>